var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"not-found-page p-tb-2"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"heading"},[_c('span',[_vm._v("OOPS...")]),_c('h1',[_vm._v("Page Not Found")])]),_c('div',{staticClass:"code-wrapper"},[_c('div',{staticClass:"error-code"},[_vm._v("404")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }